/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_value } from '../types';

export interface IsValue {
  /**
   * A value is a number, string, boolean, or object and excludes null, undefined
   *
   * @public
   * @function f1.is.uppercase
   * @example
   *
   * ```ts
   * f1.is.value(1) => false
   * f1.is.value(true) => true
   * f1.is.value({}) => true
   * f1.is.value('a') => true
   * f1.is.value(0) => true
   * f1.is.value('') => true
   *
   * f1.is.value(null) => false
   * f1.is.value(undefined) => false
   * ```
   */
  (value: string): boolean;
}

/**
 * @see IsValue
 */
export default (v: unknown): v is t_value => {
  return v === 0 || v === '' || !!v;
};
